// Live components mounted as a frosted sample would otherwise report usage nobody had.
// Kept apart from the tracking module so tests that mock that module keep this behaviour.
let suppressedDepth = 0;

/** Holds every event back until the returned release is called; nests. */
export function suppressTracking(): () => void {
  suppressedDepth += 1;
  let released = false;
  return () => {
    if (!released) {
      released = true;
      suppressedDepth -= 1;
    }
  };
}

export function isTrackingSuppressed(): boolean {
  return suppressedDepth > 0;
}
